import Marquee from "./Marquee"

const LandingDescription = () => {
    return <div className="landing-description">

        <div className="email">contato@defprojetos.com </div>
        <div className="description">
            <div className="top">From urban planning to architecture, we work
                with creativity and pragmatism, focusing on building strategic, unique and viable solutions that generate value in a broad and profound way.</div>
            <div className="bottom">
                <p>RJ +55 21 2541 6687</p>
                <p>SP +55 11 3544 3000</p>
            </div>
        </div>

    </div>
}

export default LandingDescription